import { useDayjs } from '#imports';

const dayjs = useDayjs();

export function fromNow(time: any) {
  return dayjs(time).fromNow();
}
export function duration(time: any, unit?: any) {
  return dayjs.duration(time, unit);
}

export function formatDateToMinute(time: any) {
  if (time) {
    return dayjs(time).format('YYYY/M/D HH:mm');
  }
}

export function durationSeconds(time: any) {
  if (time) {
    const d = dayjs.duration(time, 'seconds');
    let result = '',
      num = 0;
    num = d.years();
    if (num > 0) result += `${num}年`;
    num = d.months();
    if (num > 0) result += `${num}月`;
    num = d.days();
    if (num > 0) result += `${num}日`;
    num = d.hours();
    if (num > 0) result += `${num}小时`;
    num = d.minutes();
    if (num > 0) result += `${num}分钟`;
    num = d.seconds();
    if (num > 0) result += `${num}秒`;
    return result;
  }
}
export function timeSweetFormat(
  targetTime: string | number,
  nowTime?: string | number,
) {
  //有参考时间，则以参考时间为准，没有则取电脑时间
  const now = dayjs(nowTime || undefined);
  const target = dayjs(targetTime);
  if (target.isSame(now, 'day')) {
    // 当日数据，精确到分钟
    return `今天 ${target.format('H:mm')}`;
  }
  //昨天数据需要判断是不是本年
  if (
    target.year() === now.year() &&
    target.isSame(now.subtract(1, 'day'), 'day')
  ) {
    return `昨天 ${target.format('H:mm')}`;
  }
  // 当年数据，精确到月日时分
  if (target.year() === now.year()) {
    return target.format('M月D日 H:mm');
  }
  // 默认返回历史年份数据，精确到年月日时分
  return target.format('YYYY年M月D日 H:mm');
}
export function timeSweetFormat2(
  targetTime: string | number,
  nowTime?: string | number,
) {
  const now = dayjs(nowTime || undefined);
  const target = dayjs(targetTime);
  const diffInMinutes = now.diff(target, 'minute');
  const diffInHours = now.diff(target, 'hour');
  const diffInDays = now.diff(target, 'day');

  if (diffInMinutes < 5) {
    return '刚刚';
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes}分钟前`;
  } else if (diffInHours < 24) {
    return `${diffInHours}小时前`;
  } else if (diffInDays < 7) {
    return `${diffInDays}天前`;
  } else {
    return target.format('YYYY-MM-DD');
  }
}
export function formatTimeTo(time: number, format: string = 'YYYY-MM-DD') {
  return dayjs(time).format(format);
}

// 计算时间差
// 剩余13天12小时
export function timeRemain(endTime: number) {
  const now = dayjs();
  const end = dayjs(endTime);
  const diff = end.diff(now, 'hour', true);
  const hours = Math.ceil(diff);
  const days = Math.floor(diff / 24);
  const remainHours = hours - days * 24;
  if (hours > 0) {
    let res = '剩余';
    if (days > 0) {
      res += `${days}天`;
    }
    if (remainHours > 0) {
      res += `${remainHours}小时`;
    }
    return res;
  }
}
